<template>
  <el-drawer
    :withHeader="false"
    :wrapperClosable="true"
    direction="rtl"
    :visible.sync="visible"
    custom-class="pc-search-drawer"
    >
    <div class="header">
      <div>
        <el-input size="middle" v-model="text" clearable spellcheck="false" placeholder="搜索笔记本/笔记"
          prefix-icon="el-icon-search"
          @keyup.native.enter="searchHandler"
          ref="textInput">
        </el-input>
      </div>
      <div class="result-summary" v-if="result.page !== 0">
        <span class="count">
          {{result.totalCount}}个搜索结果
        </span>
      </div>
    </div>
    <div class="pc-search__result-list">
      <search-result-item :data="item" v-for="item in result.list" :key="item.resourceId"/>
    </div>
    <div class="pc-search__footer">
      <div class="pc-search__loading" v-if="loading">
        <i class="el-icon-loading"></i>
      </div>
      <div class="pc-search__result-more" v-if="hasMore && !loading">
        <el-button @click="loadMoreHandler" size="small">加载更多</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import SearchResultItem from '@/components/search/SearchResultItem.vue'
import { operateError } from '@/common/errors'

export default {
  name: 'SearchDrawer',
  components: {
    SearchResultItem
  },
  data () {
    return {
      text: '',
      pageSize: 20
    }
  },
  computed: {
    ...mapGetters('search', {
      searchVisible: 'visible',
      result: 'result',
      loading: 'loading'
    }),
    visible: {
      get () {
        return this.searchVisible
      },
      set (visible) {
        this.setVisible(visible)
      }
    },
    hasMore () {
      const pageCount = this.result.totalCount % this.pageSize === 0
        ? this.result.totalCount / this.pageSize
        : Math.floor(this.result.totalCount / this.pageSize) + 1
      return pageCount > this.result.page
    }
  },
  methods: {
    ...mapMutations('search', {
      setVisible: 'SET_VISIBLE'
    }),
    ...mapActions('search', {
      search: 'search',
      load: 'load'
    }),
    closeHandler () {
      this.setVisible(false)
    },
    async searchHandler () {
      try {
        await this.search({
          text: this.text,
          pageSize: this.pageSize
        })
      } catch (e) {
        operateError(e, '搜索')
      }
    },
    async loadMoreHandler () {
      try {
        await this.load({
          page: this.result.page + 1,
          pageSize: this.pageSize
        })
      } catch (e) {
        operateError(e, '搜索')
      }
    }
  },
  watch: {
    visible (newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.$refs.textInput.focus()
          this.$refs.textInput.select()
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';

.pc-search-drawer {
  width: 70rem !important;
  box-sizing: border-box;

  .header {
    position: sticky;
    top: 0;
    background: white;
    padding: 1.5rem 1.5rem 0;

    .el-input__inner {
      font-size: 1.6rem;
      color: $color-b1 !important;
    }
  }

  .result-summary {
    padding: 1rem 0;
    color: $color-b3;
  }

  .el-drawer__body {
    overflow-y: auto;
  }
}
.pc-search__result-list {
  padding: 0 1.5rem 1.5rem;
}
.pc-search__result-more {
  padding-bottom: 1.5rem;
  text-align: center;
}
.pc-search__footer {
  height: 6rem;
}
.pc-search__loading {
  text-align: center;
  .el-icon-loading {
    font-size: 3rem;
    color: $color-b3;
  }
}
</style>
